<ion-app>

  <ion-split-pane contentId="main-content" when="this.storage.showMenu">
    <ion-menu side="start" contentId="main-content" type="overlay">
      <ion-content style="--background:linea-gradient(to right, #000000, #ffffff)">
        <ion-card-content class="box"></ion-card-content>
        <ion-list id="inbox-list" class="menu-list">
          <!-- <br>  <br>  <br>  <br>  <br>  <br>  <br>  <br>  <br>  <br>  <br>  <br> -->

          <ion-menu-toggle >
            <ion-item>
              <ion-list-header  id="labels-list"><img src="../assets/logo_small.png" alt="logo" class="title3-logo"></ion-list-header>
            </ion-item>
          </ion-menu-toggle>
          @if (storage.login) {
            <ion-menu-toggle>
              <ion-item>
                <ion-label>{{(storage.role==='demo'?'DEMO-':'' )+ this.storage.translation.user_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (storage.login && storage.role !== 'demo') {
            <ion-menu-toggle>
              <ion-item>
                <ion-label>{{this.storage.email.toUpperCase()}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.adminAvailable && storage.login) {
            <ion-menu-toggle class="pointer" auto-hide="false">
              @if (this.storage.adminAvailable && storage.login) {
                <ion-item>
                  <ion-icon    name="football-outline"></ion-icon>
                  <ion-icon    name="chevron-forward-outline"></ion-icon>
                  <ion-toggle [(ngModel)]="storage.playerMode" (ngModelChange)="roleChanged()">PLAYER MODE: </ion-toggle>
                </ion-item>
              }
            </ion-menu-toggle>
          }
          <ion-menu-toggle>
            <ion-list-header></ion-list-header>
          </ion-menu-toggle>
          @if (this.storage.login  && (this.storage.role =='admin' || this.storage.role == 'editor')) {
            <ion-menu-toggle (click)="setVideos()" class="pointer" auto-hide="false">
              <ion-item (click)="setVideos()" >
                <ion-icon    name="videocam-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose  >SET VIDEOS</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.role =='admin') {
            <ion-menu-toggle class="pointer" auto-hide="false" (click)="challengesPage()">
              <ion-item>
                <ion-icon    name="diamond-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose  >SET CHALENGES</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.role =='admin' ) {
            <ion-menu-toggle (click)="usersPage()" class="pointer" auto-hide="false">
              <ion-item  (click)="usersPage()">
                <ion-icon    name="people-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose>USERS PAGE</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login) {
            <ion-menu-toggle  class="pointer" auto-hide="false">
              <ion-item (click)="userPage()">
                <ion-icon    name="person-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="userPage()" >{{storage.translation.userPage_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.coach.length>0 || storage.role == 'admin') {
            <ion-menu-toggle class="pointer" auto-hide="false">
              <ion-item  (click)="teamPage()" >
                <ion-icon    name="football-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="teamPage()" >{{storage.translation.teamPage_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.coach.length>0 || storage.role == 'admin' ) {
            <ion-menu-toggle class="pointer" auto-hide="false" >
              <ion-item (click)="calendarPage()">
                <ion-icon    name="calendar-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="calendarPage()">{{storage.translation.calendar_ht}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if ((this.storage.login && this.storage.coach.length>0 || storage.role == 'admin')) {
            <ion-menu-toggle class="pointer" auto-hide="false">
              <ion-item  (click)="lineupPage()" >
                <ion-icon name="clipboard-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="lineupPage()" >{{ storage.translation.lineup_t.toLocaleUpperCase()}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if ((this.storage.login && this.storage.coach.length>0 || storage.role == 'admin')) {
            <ion-menu-toggle class="pointer" auto-hide="false">
              <ion-item  (click)="postPage()" >
                <ion-icon name="mail-open-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="postPage()" >{{ storage.translation.post_t.toLocaleUpperCase()}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if ((this.storage.login || storage.role == 'admin')) {
            <ion-menu-toggle class="pointer" auto-hide="false">
              <ion-item  (click)="messagePage()" >
                <ion-icon name="mail-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="messagePage()" >{{ storage.translation.message_t.toLocaleUpperCase()}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.role =='admin') {
            <ion-menu-toggle class="pointer" auto-hide="false">
              <ion-item  (click)="clubsPage()">
                <ion-icon    name="football-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="clubsPage()" >CLUBS ADMIN</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login && this.storage.role =='admin' ) {
            <ion-menu-toggle class="pointer" auto-hide="false" >
              <ion-item (click)="translates()">
                <ion-icon    name="book-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="translates()">TRANSLATE</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login ) {
            <ion-menu-toggle class="pointer" auto-hide="false" >
              <ion-item (click)="shareVideo()">
                <ion-icon    name="share-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose (click)="shareVideo()">{{storage.translation.shareVideo_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login) {
            <ion-menu-toggle (click)="aboutPage()"  class="pointer" auto-hide="false">
              <ion-item (click)="aboutPage()">
                <ion-icon    name="information-circle-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose >{{storage.translation.about_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (this.storage.login) {
            <ion-menu-toggle (click)="logOut()" class="pointer" auto-hide="false">
              <ion-item  (click)="logOut()">
                <ion-icon    name="log-out-outline"></ion-icon>
                <ion-icon    name="chevron-forward-outline"></ion-icon>
                <ion-label menuClose  >{{storage.translation.logout_t}}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          
          <ion-menu-toggle>
            <ion-item></ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item></ion-item>
          </ion-menu-toggle>

        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
<!-- <router-outlet /> -->